import { useMemo } from 'react';
import { useLifeAreasQuery } from 'shared/hooks/queries/use-life-areas-query';
import { useUser } from 'shared/hooks/use-user';
import { useI18nLocale } from 'shared/lib/react-i18next/use-i18n-locale';
import { LifeArea } from 'shared/types/life-area';
import { getLocalizedStringValue } from 'shared/utils/get-localized-string-value';

export const useLocalizedLifeAreas = (enabled = true) => {
  const locale = useI18nLocale();
  const user = useUser();

  const { data } = useLifeAreasQuery(user?.uid, {}, enabled);

  return useMemo<LifeArea[]>(
    () =>
      data?.map(({ name, ...lifeArea }) => ({
        ...lifeArea,
        name: getLocalizedStringValue(name, locale),
      })) ?? [],
    [data, locale],
  );
};
